import useSetTransactions from '../hooks/useSetTransactions'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import useGetInitBoxPaymentOs from '../../../../pages/easyPay/initMoneyPool/hooks/useGetInitBoxPaymentOs'
import useSetGatewayPayment from '../hooks/useSetGatewayPeyment'
interface IFooterProps {
    total: number
    commission: number
    ctx_id: number
    ctx_type: string
    destination: string
    gateway: object
    isSelected: ISelectedBank
    fuckingAmount?: number
    isWallet?: boolean
}
interface IFooterGatewayPaymentProps {
    total: number
    commission: number
    destination: string
    gateway: object
    isSelected: ISelectedBank
    isWallet?: boolean
    Amount?: number
    toBePaidTransactions?: object
}
interface ISelectedBank {
    saderat: boolean
    parsian: boolean
}
export default function FooterInitGateway({
    total,
    commission,
    destination,
    gateway,
    isSelected,
    isWallet,
    Amount,
    toBePaidTransactions,
}: IFooterGatewayPaymentProps) {
    const { mutate } = useSetGatewayPayment()
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data } = useGetInitBoxPaymentOs(profile?.id)
    const { state } = useLocation()
    const navigate = useNavigate()
    const paymentItems: IPaymentItems[] = state?.toBePaidTransactions.map(
        (payment) => ({
            itemAmount: payment.amount,
            itemType: payment.type,
            itemId: payment.id,
            box_id: payment.box_id,
            commission: payment.commission,
            description: payment.description,
        })
    )
    return (
        <div className=" w-full">
            <div
                className=" mx-8 rounded-3xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                onClick={() => {
                    if (data) {
                        if (isSelected.saderat || isSelected.parsian) {
                            if (Amount) {
                                mutate({
                                    paymentItems: paymentItems,
                                    gateway: {
                                        uniqueCode: 'HAM_IPG',
                                    },
                                    clientType: 'pwa',
                                })
                            } else {
                                localStorage.setItem(
                                    'toBePaidTransactions',
                                    JSON.stringify({
                                        type: 'group-all-payment',
                                        data: state.toBePaidTransactions,
                                        //@ts-ignore
                                        pk: null,
                                        //@ts-ignore
                                        gateway: null,
                                    })
                                )
                                navigate('/group-all-payment')
                            }
                        } else {
                            toast.error('نوع درگاه پرداخت را انتخاب کنید')
                        }
                    }
                }}
            >
                پرداخت درگاهی(جدید)
            </div>
        </div>
    )
}
